import * as React from 'react';

import "./styles.css";

interface PageProps {
    children: React.ReactNode | React.ReactNode[];
    pageNumber: number;
    currentPage: number;
}

// ===============================================================================

export class SurveyActionBar extends React.PureComponent<React.ReactNode | React.ReactNode[]> {
    public render() {
        return (
            <div className="tn-survey-action-bar">
                {this.props.children}
            </div>
        );
    }
}

// ===============================================================================

export class SurveySidebar extends React.PureComponent<React.ReactNode | React.ReactNode[]> {
    public render() {
        return (
            <div className="tn-survey-sidebar">
                <nav>
                    <ul>
                        {this.props.children}
                    </ul>
                </nav>
            </div>
        );
    }
}

// ===============================================================================

export class PageContainer extends React.PureComponent<React.ReactNode | React.ReactNode[]> {
    public render() {
        return (
            <div className="tn-survey-page-container">
                {this.props.children}
            </div>
        );
    }
}

// ===============================================================================
export class Page extends React.PureComponent<PageProps> {
    public render() {

        return (
            <div className={"tn-survey-page" + (this.props.currentPage != this.props.pageNumber ? " hidden" : "")}>{this.props.children}</div>
        );
    }
}
